export default {
  lineColor: 'K',
  lineColorFull: 'Kolor linii',
  fillColor: 'W',
  fillColorFull: 'Kolor wypełnienia',
  alpha: 'A',
  alphaFull: 'Alpha',
  lineWidth: 'L',
  lineWidthFull: 'Szerokość linii',
  arrowLength: 'S',
  arrowLengthFull: 'Rozmiar strzałki',
  eraserWidth: 'G',
  eraserWidthFull: 'Wielkość gumki',
  textColor: 'K',
  textColorFull: 'Kolor tekstu',
  fontSize: 'R',
  fontSizeFull: 'Rozmiar czcionki',
  fontStrokeSize: 'Sk',
  fontStrokeSizeFull: 'Szerokość kreski',
  fontStyle: 'Sc',
  fontStyleFull: 'Styl czcionki',
  fontName: 'C',
  fontNameFull: 'Czcionka',
  textStrokeColor: 'Kk',
  textStrokeColorFull: 'Kolor kreski',
  apply: 'Zastosuj',
  cancel: 'Anuluj',
  close: 'Zamknij',
  clear: 'Wyczyść',
  width: 'Szerokość',
  height: 'Wysokość',
  keepRatio: 'Zachowaj współczynnik proporcji',
  fillPageWith: 'Wypełnij stronę obecnym kolorem tła',
  pixelSize: 'P',
  pixelSizeFull: 'Rozmiar pixela',
  resizeScale: 'Skala',
  resizeResize: 'Zmień rozmiar',
  backgroundColor: 'Kolor tła strony',
  pixelizePixelSize: 'Rozmiar pixela Pixelizera',
  language: 'Język',
  wrongPixelSizeValue:
    'Zły rozmiar pixela. Poprawne wartości to np. \'20%\', co oznacza przyjęcie rozmiaru pixela jako 20% ' +
    'pola wybranego obszaru, lub \'4\' jako 4 px',
  tools: {
    crop: 'Przytnij obraz do wybranego obszaru',
    pixelize: 'Pixelizuj wybrany obszar',
    rect: 'Rysuj prostokąt',
    ellipse: 'Rysuj elipse',
    line: 'Rysuj linię',
    arrow: 'Rysuj strzałkę',
    rotate: 'Obróć obraz',
    save: 'Zapisz obraz',
    load: 'Wczytaj obraz',
    text: 'Dodaj tekst',
    brush: 'Pędzel',
    resize: 'Zmień rozmiar lub skalę',
    open: 'Otwórz obraz',
    select: 'Wybierz obszar',
    close: 'Zamknij Painterro',
    eraser: 'Gumka',
    settings: 'Ustawienia',
    undo: 'Cofnij',
    redo: 'Przywróć',
  },
  pasteOptions: {
    fit: 'Zastąp',
    extend_down: 'Dodaj poniżej',
    extend_right: 'Dodaj po prawej',
    extend: 'Dodaj',
    over: 'Dodaj ponad',
    how_to_paste: 'Jak wkleić?',
  },
};
